import { TaxResultItemType } from './tax-result-item-type';

export class TaxPolicy {
  taxPolicyId!: number;
  name!: string;
  isActive!: boolean;
  taxResultItemType!: TaxResultItemType;
}
